var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v("Add users")]),
      _c("w-data-table", {
        staticStyle: { "flex-grow": "1" },
        attrs: {
          columns: _vm.columns,
          items: _vm.users,
          "selected-items": _vm.selectedRows,
        },
      }),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.selectedRows.length == 0 },
              on: {
                click: function ($event) {
                  return _vm.add()
                },
              },
            },
            [_vm._v(" Add ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }